import React, { Suspense, useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAreCardsActivated } from "~Shared/hooks/corporate.hooks"
import { AuthzService } from "~Shared/services"
import { fetchCardOverviewData } from "~Shared/store/actions/analytics/analyticsActions"
import { fetchKYBProgress, fetchWallet } from "~Shared/store/actions/corporate/corporateActions"
import { lazily } from "~Shared/utils/react.utils"

const { CreditCardsList } = lazily(() => import("~Features/pages/creditCards/CreditCardsList"))
const KYBContainer = React.lazy(() => import("~Features/pages/creditCards/kyb/kyb.container"))

export const CreditCardsContainer = () => {
    const dispatch = useDispatch()
    const showCardList = useAreCardsActivated()

    useEffect(() => {
        dispatch(fetchKYBProgress())
    }, [])

    useEffect(() => {
        if (!showCardList) {
            return
        }

        if (AuthzService.canLoggedInUserViewAllCards()) {
            dispatch(fetchCardOverviewData())
        }

        if (AuthzService.canLoggedInUserViewWallet()) {
            dispatch(fetchWallet())
        }
    }, [showCardList])

    return <Suspense fallback={<></>}>{showCardList ? <CreditCardsList /> : <KYBContainer />}</Suspense>
}
